import React from 'react';

const BOOKING_URL = process.env.REACT_APP_BOOKING_URL || 'https://agenda.filtrosyaceitesjm.com/login';

const TemplateElegant = ({ data, config }) => {
  const activeServices = Array.isArray(data?.services) && data.services.length > 0
    ? config.services.filter(s => data.services.includes(s.id))
    : config.services.slice(0, 6);

  const primary = data.brand_color_primary || '#1e293b';
  const secondary = data.brand_color_secondary || '#a855f7';

  return (
    <div className="min-h-screen bg-[#faf8f5] text-gray-800 font-serif">
      {/* Hero Section */}
      <header className="relative min-h-[80vh] flex items-center">
        <div className="absolute inset-0 w-full h-full">
          <img src={data.hero_image_url || config.images[0].url} alt="Hero" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-white/70 backdrop-blur-sm"></div>
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <h1 className="text-5xl md:text-7xl font-light mb-6 text-gray-900">
            {data.name || config.defaultTitle}
          </h1>
          <div className="w-24 h-1 mx-auto mb-6" style={{ backgroundColor: secondary }}></div>
          <p className="text-lg md:text-xl text-gray-600 mb-10 max-w-2xl mx-auto tracking-wide">
            {config.defaultDescription}
          </p>
          <button
            className="px-10 py-4 rounded-none uppercase tracking-widest text-sm transition-opacity hover:opacity-80 font-semibold"
            style={{ border: `1px solid ${primary}`, color: primary, backgroundColor: 'transparent' }}
            onClick={() => { window.location.href = `${data.booking_url || BOOKING_URL}?workshopId=${data.id}&niche=${data.niche}`; }}
          >
            Reservar Experiencia
          </button>
        </div>
      </header>

      {/* Services Section */}
      <section className="py-24 px-6 relative overflow-hidden" style={{ background: `linear-gradient(135deg, #f5f0ff 0%, #faf8f5 50%, #f0f4ff 100%)` }}>
        {/* Blobs decorativos */}
        <div className="absolute top-0 right-0 w-96 h-96 rounded-full opacity-20 blur-3xl -translate-y-1/2 translate-x-1/3" style={{ backgroundColor: secondary }}></div>
        <div className="absolute bottom-0 left-0 w-72 h-72 rounded-full opacity-10 blur-3xl translate-y-1/2 -translate-x-1/4" style={{ backgroundColor: primary }}></div>

        <div className="relative max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-light text-gray-900 mb-4">Servicios Exclusivos</h2>
            <div className="w-16 h-px mx-auto" style={{ backgroundColor: secondary }}></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {activeServices.map((service, index) => (
              <div
                key={index}
                className="relative p-7 rounded-2xl transition-all duration-300"
                style={{
                  background: 'rgba(255,255,255,0.55)',
                  backdropFilter: 'blur(20px)',
                  WebkitBackdropFilter: 'blur(20px)',
                  border: `1px solid rgba(255,255,255,0.9)`,
                  boxShadow: `0 4px 24px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255,255,255,1)`,
                }}
              >
                {/* Shine */}
                <div className="absolute inset-0 rounded-2xl pointer-events-none" style={{ background: 'linear-gradient(135deg, rgba(255,255,255,0.55) 0%, transparent 40%)' }}></div>
                <div className="absolute top-0 left-8 right-8 h-px" style={{ background: `linear-gradient(to right, transparent, ${secondary}60, transparent)` }}></div>

                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center mb-5 text-2xl"
                  style={{
                    background: `linear-gradient(135deg, ${secondary}20, ${secondary}08)`,
                    border: `1px solid ${secondary}25`,
                  }}
                >
                  {service.icon}
                </div>
                <h3 className="text-lg font-semibold capitalize mb-2 text-gray-900">{service.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default TemplateElegant;
